export default __webpack_public_path__ + "static/media/license.558e0c89.svg";